import React, { useEffect, useRef, useState } from "react";
import { Table, Button, Spinner, Badge, Pagination, FormSelect, FormControl, InputGroup } from "react-bootstrap";
import { ChevronLeft, Filter, Gear, PlusLg, XLg } from "react-bootstrap-icons";
import { fetchApi, range } from "../../../Funciones";
import { useAuth } from "../../../Auth";
import { useNavigate } from "react-router-dom";
import { TagList, TagSelector } from "../Tags/Manager";
import { SelectorLista } from "../../SelectorLista";
import { ControlesOrden, Orden } from "../../Orden";

export const Home: React.FC = () => {
	let auth = useAuth();
	let nav = useNavigate();

	const [filtro, setFiltro] = useState("")
	const [listado, setListado] = useState<any>([])
	const [pagina, setPagina] = useState(0)
	const [porPagina, setPorPagina] = useState(localStorage.getItem("porPagina") ? parseInt(localStorage.getItem("porPagina") + "") : 10)
	const [cargando, setCargando] = useState(false)
	const [total, setTotal] = useState(0)
	const [filtroTags, setFiltroTags] = useState<any[]>(localStorage.getItem("fTags") ? JSON.parse(localStorage.getItem("fTags") + "") : [])
	const [filtroEstados, setFiltroEstados] = useState<any[]>(localStorage.getItem("fEstados") ? JSON.parse(localStorage.getItem("fEstados") + "") : [])

	const getData = async () => {
		setCargando(true)
		var data = await fetchApi(auth.user.token, "content", {
			cmd: "search",
			s: filtro,
			p: pagina,
			pp: porPagina,
			tags: filtroTags.map(item => item.id).join(","),
			estados: filtroEstados.map(item => item.id).join(",")
		})
		setListado(data.listado)
		setTotal(data.total)
		setCargando(false)
	}

	var paginas = range(1, Math.ceil(total / porPagina) + 1)

	useEffect(() => {
		return () => clearTimeout(timeRef.current!)
	}, [])

	const timeRef = useRef<any>(null)
	useEffect(() => {
		if (auth.user) {
			clearTimeout(timeRef.current!)
			timeRef.current = setTimeout(() => {
				getData()
			}, 300)
		}
		// eslint-disable-next-line
	}, [auth.user, filtro])

	useEffect(() => {
		if (auth.user) {
			clearTimeout(timeRef.current!)
			getData()
		}
		// eslint-disable-next-line
	}, [auth.user, filtroTags, filtroEstados, pagina, porPagina])

	let filtradas = listado;
	//orden
	const [orden, setOrden] = useState<Orden>({ columna: -1, ascendente: true });
	useEffect(() => {
		setOrden({ columna: -1, ascendente: false });
	}, [])

	if (orden.columna !== -1) {
		switch (orden.columna) {
			case 0:
				filtradas = filtradas.sort((a: any, b: any) => a.publish_date.localeCompare(b.publish_date) * (orden.ascendente ? 1 : -1))
				break;
			case 1:
				filtradas = filtradas.sort((a: any, b: any) => a.title.localeCompare(b.title) * (orden.ascendente ? 1 : -1))
				break;
			case 2:
				filtradas = filtradas.sort((a: any, b: any) => a.state.localeCompare(b.state) * (orden.ascendente ? 1 : -1))
				break;
		}
	}

	return <>
		<Button size="sm" variant="dark" onClick={() => { nav(-1) }} className="my-2"><ChevronLeft /> Volver</Button>
		<h4>Contenidos</h4>

		<div className="py-2">
			<Button variant="outline-dark" className="d-inline-block" onClick={() => nav("edit")}>Agregar nuevo contenido <PlusLg /></Button>
			<div className="d-inline-block ms-4">
				<InputGroup>
					<FormControl type="text" placeholder='Buscar' value={filtro} onChange={(ev) => setFiltro(ev.target.value)} />
					<Button variant="outline-danger" onClick={() => setFiltro("")}><XLg /></Button>
				</InputGroup>
			</div>
			<FormSelect className="d-inline-block w-auto ms-4" title="Por Página" value={porPagina} onChange={(ev) => {
				setPagina(0)
				setPorPagina(parseInt(ev.target.value));
				localStorage.setItem("porPagina", ev.target.value)
			}}>
				<option value={10}>10</option>
				<option value={25}>25</option>
				<option value={50}>50</option>
				<option value={100}>100</option>
			</FormSelect>
			{total > porPagina && <div className="d-inline-block ms-4">
				<Pagination>
					<Pagination.First onClick={() => setPagina(0)} />
					{paginas.map(p => <Pagination.Item key={p} onClick={() => setPagina(p - 1)} active={pagina === p - 1}>{p}</Pagination.Item>)}
					<Pagination.Last onClick={() => setPagina(paginas.length - 1)} />
				</Pagination>
			</div>}
			<div className={"d-inline-block ms-4 border px-2 py-1 " + (filtroTags.length > 0 ? "border border-primary rounded" : "")}>
				{filtroTags.length > 0 && <div><TagList list={filtroTags} /></div>}
				<TagSelector current={filtroTags} onSelect={(tags: any) => {
					localStorage.setItem("fTags", JSON.stringify(tags))
					setFiltroTags(tags)
				}}><Button size="sm" variant="secondary"><Filter /> Filtrar Etiquetas</Button></TagSelector>
			</div>
			<div className={"d-inline-block ms-4 border px-2 py-1 " + (filtroEstados.length > 0 ? "border border-primary rounded" : "")}>
				{filtroEstados.length > 0 && <div className="mb-2">
					{filtroEstados.map((item: any) => {
						return <Badge key={item.id} bg={item.bg ? item.bg : "secondary"} className="me-2">{item.text}</Badge>
					})}
				</div>}
				<SelectorLista
					current={filtroEstados}
					lista={Object.keys(EstadosContenido).map(key => { return { id: key, text: EstadosContenido[key as keyof typeof EstadosContenido].text, bg: EstadosContenido[key as keyof typeof EstadosContenido].bg } })}
					onSelect={(estados: any[]) => {
						localStorage.setItem("fEstados", JSON.stringify(estados))
						setFiltroEstados(estados)
					}}>
					<Button size="sm" variant="secondary"><Filter /> Filtrar Estados</Button>
				</SelectorLista>
			</div>
			{cargando && <Spinner animation="border" className="d-inline-block ms-4" />}
		</div>

		{listado && listado.length > 0 && <Table bordered hover striped size="sm" className="shadow">
			<thead>
				<tr>
					<th className="text-center">ID</th>
					<th className="text-center">Acciones</th>
					<th className="text-center">Fecha Publicación <ControlesOrden columna={0} orden={orden} handler={setOrden} /></th>
					<th>Título <ControlesOrden columna={1} orden={orden} handler={setOrden} /></th>
					<th>Etiquetas</th>
					<th className="text-center">Estado <ControlesOrden columna={2} orden={orden} handler={setOrden} /></th>
				</tr>
			</thead>
			<tbody>
				{filtradas.map((item: any, i: any) => <tr key={item.id}>
					<td className="text-center" width={60}>{item.id}</td>
					<td className="text-center" width={120} style={{ verticalAlign: "middle" }}>
						<Button size="sm" variant="dark" onClick={() => nav("edit/" + item.id)}><Gear /> Editar</Button>
					</td>
					<td className="text-center small" width={180}>
						<Badge bg="dark">{item.publish_date.split(" ")[0]}</Badge><br />
						<Badge bg="secondary">{item.publish_date.split(" ")[1].split(":").splice(0, 2).join(":")}</Badge>
					</td>
					<td>{item.title}</td>
					<td>
						<TagList list={item.tags} />
					</td>
					<td className="text-center" width={200} style={{ verticalAlign: "middle" }}>
						<Badge bg={EstadosContenido[item.state as keyof typeof EstadosContenido].bg}>
							{EstadosContenido[item.state as keyof typeof EstadosContenido].text}
						</Badge>
					</td>
				</tr>)}
			</tbody>
		</Table>}

		<div className="py-2">
			{total > porPagina && <div className="d-inline-block ms-4">
				<Pagination>
					<Pagination.First onClick={() => setPagina(0)} />
					{paginas.map(p => <Pagination.Item key={p} onClick={() => setPagina(p - 1)} active={pagina === p - 1}>{p}</Pagination.Item>)}
					<Pagination.Last onClick={() => setPagina(paginas.length - 1)} />
				</Pagination>
			</div>}
		</div>
	</>
}
export const EstadosContenido = {
	Draft: {
		text: "Borrador",
		bg: "secondary",
	},
	Published: {
		text: "Publicado",
		bg: "primary",
	},
	Deleted: {
		text: "Eliminado",
		bg: "danger",
	}
}